import { useMutation, useQueryClient } from '@tanstack/react-query';
import SurveyAPI from 'apis/SurveyAPI';
import { surveyKeys } from '../queries';

export function useUpdateSurveyQuestion(surveyId, options = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ questionId, questionType }) =>
      SurveyAPI.updateSurveyQuestion(questionId, questionType),

    onSuccess: (result, variables) => {
      const { questionId } = variables;

      // Invalidate the specific question query
      queryClient.invalidateQueries({
        queryKey: surveyKeys.question(questionId)
      });

      // Invalidate survey questions list to refresh the table
      if (surveyId) {
        queryClient.invalidateQueries({
          queryKey: surveyKeys.surveyQuestions(surveyId)
        });

        // Invalidate survey rows to get updated survey answers
        queryClient.invalidateQueries({
          queryKey: surveyKeys.all
        });
      }

      // Call any additional onSuccess callback
      if (options.onSuccess) {
        options.onSuccess(result, variables);
      }
    },

    onError: (error, variables) => {
      // Call any additional onError callback
      if (options.onError) {
        options.onError(error, variables);
      }
    }
  });
}